export default {
    "ctt": "Chưa thanh toán",
    "ddc": "Đã đặt cọc",
    "tt1p": "Thanh toán 1 phần",
    "dtt": "Đã thanh toán",
}
